import { useEffect, useRef, useState } from "react";

import { Icon } from "../components/Icon";
import { NewContactModal } from "../forms/NewContact";
import { NewLeadModal } from "../forms/NewLead";
import { NewTaskModal } from "../forms/NewTask";

type Kind = "contact" | "lead" | "task";

export function NewRecordMenu() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState<Kind | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    const esc = (e: KeyboardEvent) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", close);
    document.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("mousedown", close);
      document.removeEventListener("keydown", esc);
    };
  }, [open]);

  const choose = (kind: Kind) => {
    setOpen(false);
    setForm(kind);
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        className="btn btn-primary"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name="plus" />
        New
      </button>
      {open && (
        <div className="menu" role="menu" style={{ right: 0, top: "calc(100% + 6px)" }}>
          <button className="menu-item" role="menuitem" onClick={() => choose("contact")}>
            <Icon name="user" /> Contact
          </button>
          <button className="menu-item" role="menuitem" onClick={() => choose("lead")}>
            <Icon name="inbox" /> Lead
          </button>
          <button className="menu-item" role="menuitem" onClick={() => choose("task")}>
            <Icon name="checkSquare" /> Task
          </button>
        </div>
      )}
      {form === "contact" && <NewContactModal onClose={() => setForm(null)} />}
      {form === "lead" && <NewLeadModal onClose={() => setForm(null)} />}
      {form === "task" && <NewTaskModal onClose={() => setForm(null)} />}
    </div>
  );
}
